<template>
  <StyledDiv>
    <StyledDiv
      height="450px"
      :backgroundImage="headShot"
      backgroundPosition="bottom"
      padding="0 15px"
      backgroundSize="90%"
      class="girlsDesk"
    >
      <StyledText
        :fontSize="styled('fontSize-medium')"
        lineHeight="2"
        :fontFamily="styled('fontFamily-GothamLight')"
        :smallTabletFontSize="styled('fontSize-mediumSmall')"
        :mobileFontSize="styled('fontSize-small')"
        >Interested in learning more?</StyledText
      >
      <StyledText
        :fontSize="styled('fontSize-medium')"
        lineHeight="1.5"
        :fontFamily="styled('fontFamily-GothamLight')"
        :smallTabletFontSize="styled('fontSize-mediumSmall')"
        :mobileFontSize="styled('fontSize-small')"
        >Want to see a demonstration?</StyledText
      >
      <StyledText
        :fontSize="styled('fontSize-medium')"
        lineHeight="1.5"
        :fontFamily="styled('fontFamily-GothamLight')"
        :smallTabletFontSize="styled('fontSize-mediumSmall')"
        :mobileFontSize="styled('fontSize-small')"
        >Have questions about the languages we've tested so far?</StyledText
      >
      <StyledText
        :fontSize="styled('fontSize-medium')"
        lineHeight="1.5"
        :fontFamily="styled('fontFamily-GothamLight')"
        :smallTabletFontSize="styled('fontSize-mediumSmall')"
        :mobileFontSize="styled('fontSize-small')"
        >Want to try the Literacy Loom software?</StyledText
      >
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
import headerImage from "../assets/images/girlsDesk.jpg";

export default {
  components: {
    StyledDiv,
    StyledText
  },
  data() {
    return { headShot: headerImage };
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
@media (max-width: 768px) {
  .girlsDesk {
    background-size: cover;
  }
}
</style>
